import React from 'react';
import { useSelector } from 'react-redux';
import Inbox from '../Icons/Inbox.js';
import EmailInteraction from './EmailInteraction.js';
import RecipientContent from './RecipientContent.js';
const Other = (props) => {
    const lang = useSelector((s) => s.lang);
    const tabs = [
        {
            children: (React.createElement(EmailInteraction, { referenceId: props.referenceId, referenceType: props.referenceType, isCourt: true, contactRecipient: true })),
            icon: Inbox,
            label: lang.interactionTypes.EMAIL,
        },
    ];
    return React.createElement(RecipientContent, { tabs: tabs });
};
export default Other;
//# sourceMappingURL=Other.js.map